export default __webpack_public_path__ + "static/media/electromagnetic_control_rod.11a82771.png";